import { setVariables } from "./common/setvariables.es6";
import { ua } from "./common/ua.es6";
import ScrollFunc from "./scroll.es6";

export default class Main {
    constructor() {
        this.init();
    }

    init() {
        ua();
        setVariables();
        this.setScrollFunc();
        this.intro();
    }

    setScrollFunc() {
        window.addEventListener("onIntroEnd", () => {
            const scrollFunc = new ScrollFunc();
        });
    }

    intro() {
        const introEndEvent = new CustomEvent("onIntroEnd");
        const introElm = document.querySelector(".intro");
        const skipButton = document.querySelector(".js-introskip");
        const url = new URL(window.location.href);
        const params = url.searchParams;

        //スクロールリセット
        window.addEventListener("beforeunload", () => {
            window.scrollTo(0, 0);
        });

        const onEnd = () => {
            document.body.setAttribute("data-introend", "1");
            document.body.setAttribute("data-skipped", "1");
            window.dispatchEvent(introEndEvent);
        };

        if (!introElm) {
            onEnd();
            return;
        }

        //skipパラメータがあるときはSKIP
        if (params.get("skip")) {
            onEnd();
        } else {
            document.body.setAttribute("data-ready", "1");
        }

        setTimeout(() => {
            onEnd();
        }, 13500);

        skipButton.addEventListener("click", onEnd);
    }
}
